<template>
  <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in" appear>
      <component :is="Component"><slot /></component>
    </transition>
  </router-view>
</template>

<script setup>
import { useAppStore } from '@stores/app.js'

const props = defineProps(['user', 'base_url', 'entity'])
const store = useAppStore()

// Initialize store with props on component creation
store.setEntity(props.entity)
if (props.user) {
    store.setUser(props.user)
    store.setLoggedIn(true)
    store.setBaseUrl(props.base_url)
}
</script>
